import c1 from "../wardrobe/c1.jpeg"
import c2 from "../wardrobe/c2.jpeg"
import c3 from "../wardrobe/c3.jpeg"
import c4 from "../wardrobe/c4.jpeg"
import c5 from "../wardrobe/c5.jpeg"
import c6 from "../wardrobe/c6.jpeg"
import c7 from "../wardrobe/c7.jpeg"
import c8 from "../wardrobe/c8.jpeg"
import c9 from "../wardrobe/c9.jpeg"
import c10 from "../wardrobe/c10.jpeg"
import c11 from "../wardrobe/c11.jpeg"
import c12 from "../wardrobe/c12.jpeg"
import c13 from "../wardrobe/c13.jpeg"
import c14 from "../wardrobe/c14.jpeg"
import c15 from "../wardrobe/c15.jpeg"
import c16 from "../wardrobe/c16.jpeg"
import c17 from "../wardrobe/c17.jpeg"
import c18 from "../wardrobe/c18.jpeg"
import c19 from "../wardrobe/c19.jpeg"
import c20 from "../wardrobe/c20.jpeg"
import c21 from "../wardrobe/c21.jpeg"
import c22 from "../wardrobe/c22.jpeg"
import c23 from "../wardrobe/c23.jpeg"
import c24 from "../wardrobe/c24.jpeg"



function Wardrobe() {
  return (

    <div class="container">
      <h1>Wardrobe Work</h1>
      <h4>Trusted by hundreds of clients — here’s a look at our work.</h4>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img src={c1} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c2} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c3} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c4} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c5} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c6} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c7} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c8} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c9} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c10} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c11} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c12} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>

        <div class="col">
          <div class="card shadow-sm">
            <img src={c13} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c14} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c15} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c16} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c17} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c18} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c19} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c20} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c21} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c22} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c23} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={c24} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
      </div>
      <p><a class="btn btn-success" href="https://www.instagram.com/invites/contact/?igsh=1izl3bvvj2uj3&utm_content=zvshzkp">View more &raquo;</a></p>
      <hr class="featurette-divider" /></div>

  );
}

export default Wardrobe;
